import type { ReactNode } from 'react';

interface ScreenProps {
  children: ReactNode;
  /** Optional max width so the app does not stretch to full bleed on tablets and desktop. */
  maxWidth?: string;
}

// Standard mobile-first screen container. Centred, max 460px on phones, breathable padding.
// Same width discipline as the rest of the Creative Sauce app UI standard.
//
// Bottom padding (pb-28) leaves room for the persistent BottomNav so content does not
// get hidden behind it.
export function Screen({ children, maxWidth = 'max-w-[460px]' }: ScreenProps) {
  return (
    <main className="min-h-full w-full flex justify-center">
      <div className={`w-full ${maxWidth} px-6 pt-8 pb-28 flex flex-col`}>{children}</div>
    </main>
  );
}
